module.exports = __webpack_public_path__ + "img/floor-shangcheng.78b41196.png";